import React, { useMemo, memo } from "react";
import { useTranslation } from "react-i18next";
import { Student } from "@/types/Student";
import { useFetchStudents } from "@/hooks/useFetchStudents";
import { FilterContext } from "@/types/FilterContext";
import { StudentOrdering } from "@/types/StudentOrdering";
import {
  StudentListCommunityToolsSortableFieldEnum,
  SortDirectionEnum,
  YesNoEnum,
} from "@/__generated__/types";
import { useBuildUrlState } from "@/hooks/useUrlSerializer";
import { StudentCarousel } from "@/components/StudentCarousel";
import { FilterState } from "@/components/FilterSidebar/FilterState";

export const RecentlyReachedCarousel = memo(function RecentlyReachedCarousel() {
  const { t } = useTranslation();
  const ordering = useMemo(
    () =>
      new StudentOrdering(
        StudentListCommunityToolsSortableFieldEnum.RecentlyReachedAt,
        SortDirectionEnum.Desc,
        "communityTools",
      ),
    [],
  );

  const context = useMemo(() => new FilterContext("communityTools"), []);

  const { items: students, loading } = useFetchStudents({
    paginationVariables: {
      first: 10,
    },
    ordering,
    context,
    filterState: new FilterState({ hasProfilePhoto: YesNoEnum.Yes }),
  });

  const orderingQuery = useBuildUrlState("STUDENT_ORDERING")(ordering);
  const fc = useBuildUrlState("FILTER_CONTEXT")(context);

  return (
    <StudentCarousel
      title={t("home.overview.recentlyReached")}
      students={students as Student[]}
      isLoading={loading}
      showLocation={true}
      viewAllLink={"students"}
      viewAllQuery={{ ...orderingQuery, ...fc }}
      viewAllSource="Community Tools - Recently Reached"
      profileSource="Overview - Students Reached"
    />
  );
});
